import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ILaunchWebAuthoringAction } from '../../../../ts/ServerApi/types/actionNames';
import { newWorkbookForDatasource } from '../../../actions/spaces/NewWorkbookForDatasourceAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';
import { hideLaunchEditOnMobile } from '../../../utils/MobileHelper';

export const NewWorkbookEntityAction: IEntityAction<IContentInfo<'datasource'>, ILaunchWebAuthoringAction> = {
  name: EntityActionNames.NewWorkbook,
  translateName: Messages.newWorkbook,
  isVisible: (targetItems: IContentInfo[]) => {
    return !isSingleEmbeddedDatasource(targetItems) && !hideLaunchEditOnMobile();
  },
  isClickable: (availableActions: ILaunchWebAuthoringAction, targetItems: IContentInfo[]) =>
      targetItems.length === 1 && availableActions && availableActions.launchWebAuthoring,
  createReduxAction: (targetItems: IContentInfo[]) => {
    if (targetItems.length !== 1) {
      return;
    }

    const item = targetItems[0];
    if (item.contentType === 'datasource') {
      return newWorkbookForDatasource(item);
    }
  }
};
